require('./PendingDocumentation.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
// @ components
const { LoadingSection } = require('commonsComponents/loadingSection');
// @ commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { FormattedText } = require('core/i18n').i18n;
// @ constants
const {
    FIOC_DOC_STATUS_MISSING,
    FIOC_DOC_STATUS_MISSING_2
} = require('constants/fioc');
// @ helpers
const { fiocUpdateDocumentClickTagging } = require('utilities/taggingInfo/fiocTags');

class PendingDocumentation extends React.Component {

    constructor(props) {
        super(props);

        this.handleUpdateDocumentsButtonClick = this.handleUpdateDocumentsButtonClick.bind(this);
    }

    buildPendingDocumentsList() {
        const { immFiocDocumentation } = this.props;
        return immFiocDocumentation.get('documentList').map((document, index) => {
            if (this.documentIsMissing(document)) {
                return (<li key={index}>{document.get('nombreDocumento')}</li>);
            }
        });
    }

    documentIsMissing(document){
        return [
            FIOC_DOC_STATUS_MISSING,
            FIOC_DOC_STATUS_MISSING_2
        ].includes(document.get('estadoDocumento'));
    }

    handleUpdateDocumentsButtonClick() {
        fiocUpdateDocumentClickTagging();
        this.props.history.push('/myprofile/edit/fioc');
    }

    noPendingDocuments() {
        const { immFiocDocumentation } = this.props;
        return immFiocDocumentation.get('fetched') && !immFiocDocumentation.get('documentationRequested');
    }

    shouldShowPendingDocuments() {
        const { immFiocDocumentation } = this.props;
        return immFiocDocumentation.get('fetched') && immFiocDocumentation.get('documentationRequested');
    }

    render() {
        const { immFiocDocumentation } = this.props;
        let content = null;

        if (immFiocDocumentation.get('isStatusFetching')){
            content = <LoadingSection />;
        } else if (this.shouldShowPendingDocuments()){
            content = (
                <div>
                    <FormattedText
                        className="pending-documentation__title-text"
                        value="profileFioc-successStepDocumentsPending"
                    />
                    <ul className="pending-documentation__list">
                        {this.buildPendingDocumentsList()}
                    </ul>
                    <OKButton
                        modifier="secondary"
                        onClick={this.handleUpdateDocumentsButtonClick}
                        size="regular"
                    >
                        <FormattedText value="profileFioc-successStepDocumentsButton" />
                    </OKButton>
                </div>
            );
        } else if (this.noPendingDocuments()) {
            content = (
                <FormattedText
                    className="pending-documentation__title-text"
                    value="profileFioc-successStepDocumentsUpToDate"
                />
            );
        }

        return <section className="pending-documentation">{content}</section>;
    }
}

PendingDocumentation.propTypes = {
    history: PropTypes.object.isRequired,
    immFiocDocumentation: PropTypes.object.isRequired,
};

module.exports = withRouter(PendingDocumentation);
